import { render, staticRenderFns } from "./complaint-report.vue?vue&type=template&id=abdfdc20&"
import script from "./complaint-report.vue?vue&type=script&lang=js&"
export * from "./complaint-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports